<ng-content></ng-content>
<div class="form-notch">
  <div #notchLeading class="form-notch-leading"></div>
  <div #notchMiddle class="form-notch-middle"></div>
  <div class="form-notch-trailing"></div>
</div>
